import { findBrandByDomain } from "../configs/configLoader";
import { TFunction } from "i18next";
import { logger } from "./logging";

const urlParameters = new URLSearchParams(window.location.search);
const isChildren =
  urlParameters.get("category") === "children" ||
  urlParameters.get("kids") === "true";

export const handleMoveToNextInput = (
  index: number,
  unit: string,
  inputRefs: React.RefObject<HTMLInputElement>[],
  isTabClicked?: boolean
) => {
  const brandDefined = findBrandByDomain();

  if (index >= 5 && !isTabClicked) return;

  const unitNextIndex =
    index === 1 ? 2 : index === 2 ? 3 : index === 3 ? 4 : -1;
  const nextIndex =
    unit === "feet" || unit === "year" || unit === "month"
      ? unitNextIndex
      : index === 0
      ? 3
      : index === 3
      ? 4
      : index === 4
      ? 5
      : -1;

  const targetInput = nextIndex !== -1 ? inputRefs[nextIndex].current : null;

  if (targetInput && nextIndex !== -1) {
    setTimeout(() => {
      if (brandDefined?.name === "Lacoste") {
        if (nextIndex === 4) {
          targetInput.focus({ preventScroll: true });
        } else {
          targetInput.focus();
        }

        const inputs = document.querySelectorAll("input");

        inputs.forEach((input) => {
          input.addEventListener("touchstart", () => {
            setTimeout(() => {
              window.scrollTo({
                top: 0,
                behavior: "smooth",
              });
            }, 0);
          });
        });
      }

      targetInput.select();
    }, 100);
  }
};

export const isPhysicalAndroidDevice = () => {
  try {
    const ua = navigator.userAgent || "";
    const platform = navigator.platform || "";

    const isAndroid =
      /Android/i.test(ua) && /(Linux|arm|x86|x64)/i.test(platform);

    const hasTouch = "ontouchstart" in window && navigator.maxTouchPoints > 0;

    let screenWidth = 0;
    let screenHeight = 0;

    try {
      screenWidth = Math.min(
        window.screen?.width || 0,
        window.screen?.height || 0
      );
      screenHeight = Math.max(
        window.screen?.width || 0,
        window.screen?.height || 0
      );
    } catch (e) {
      logger.warn("[DeviceCheck] screen access failed:", e);
    }

    const isMobileScreen = screenWidth <= 480 && screenHeight <= 800;

    const isRealDevice = !!(
      navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 8
    );

    return isAndroid && hasTouch && (isMobileScreen || isRealDevice);
  } catch (err) {
    logger.warn("[DeviceCheck] detection failed:", err);
    return false;
  }
};

export const getWeightPlaceholder = (
  unitWeight: string,
  t: TFunction<"components/intro", undefined>
) => {
  if (isChildren) {
    return unitWeight === "kg"
      ? t("weight.children.placeholderKG")
      : t("weight.children.placeholderLBS");
  }
  return unitWeight === "kg"
    ? t("weight.placeholderKG")
    : t("weight.placeholderLBS");
};

export const getHeightCMPlaceholder = (
  t: TFunction<"components/intro", undefined>
) => {
  return isChildren
    ? t("height.children.placeholder")
    : t("height.placeholder");
};

export const getHeightFeetPlaceholder = (
  t: TFunction<"components/intro", undefined>
) => {
  return isChildren
    ? t("height.children.placeholderfeet")
    : t("height.placeholderfeet");
};
export const getHeightFeetGivenchyPlaceholder = (
  t: TFunction<"components/intro", undefined>
) => {
  return isChildren
    ? t("height.children.placeholderFeet")
    : t("height.placeholderFeet");
};

export const getHeightInchPlaceholder = (
  t: TFunction<"components/intro", undefined>
) => {
  return isChildren
    ? t("height.children.placeholderinches")
    : t("height.placeholderinches");
};
